import { render, staticRenderFns } from "./EqsNumberShares.vue?vue&type=template&id=74af3164"
import script from "./EqsNumberShares.vue?vue&type=script&lang=js"
export * from "./EqsNumberShares.vue?vue&type=script&lang=js"
import style0 from "./EqsNumberShares.vue?vue&type=style&index=0&id=74af3164&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports